import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    flex: 1,
    height: '100%',
    position: 'relative',
  },

  tabs: {
    display: 'flex',
    gap: theme.spacing(4.5),
  },

  tab: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),

    fontWeight: 600,
    fontSize: 15,
    textTransform: 'uppercase',

    cursor: 'pointer',
    color: theme.palette.text.secondary,

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },

  activeTab: {
    color: theme.palette.text.primary,
  },
}));
